import React from 'react';
import { connect } from 'react-redux';
import { autobind } from 'core-decorators';
import Layout from '../components/Layout/LayoutIndex';
import { getHtmlTDK, getNameByKey } from '../../../lib/utils/UtilsCommon';
import './AboutQlEdu.less';

/**
 * state
 */
interface IState {
	htmlTDK: {
		title: string;
	};
}

/**
 * HomeTraining page
 *
 * @class HomeTraining
 * @extends {React.Component<any>}
 */
@autobind
class AboutQlEdu extends React.Component<any, any> {
	constructor(props: any, context?: any) {
		super(props, context);

		/**
		 * 静态化渲染数据放这里处理
		 */

		let { initData } = props;
		const state: any = {
			htmlTDK: {
				title: '兴趣岛公司介绍——名师更多，课程更全',
				pageDescription: '兴趣岛兴趣学堂-名师更多，课程更全。摄影、瑜伽等30门主流课程21门学员数量全国领先。',
				pageKeyword: '兴趣,兴趣岛,兴趣岛兴趣学堂,兴趣学堂,千聊兴趣岛,兴趣岛-名师更多，课程更全,兴趣岛兴趣学堂-名师更多，课程更全,千聊,知识付费,内容付费,千聊特训营,成人教育',
			},
		};

		this.state = state;
	}

	/**
	 * 动态渲染数据放这里处理
	 *
	 * @static
	 * @param {*} { req }
	 * @returns {Promise<any>}
	 * @memberof HomeTraining
	 */
	public static async getInitialProps(context: any): Promise<any> {
		console.log('关于页面');

		return {};
	}

	componentDidMount(): void {
		this.setState({
			host: location.host,
		});
	}

	/**
	 * 渲染页面
	 *
	 * @returns {*}
	 * @memberof HomeTraining
	 */
	public render(): any {
		const { htmlTDK, host } = this.state;

		return (
			<Layout {...getHtmlTDK(htmlTDK)} bodyClass="home-about-page" region="create-live_pc_homepage_top_tab" activeTab="about">
				<div className="middle">
					<div className="section animateUp" style={{ marginTop: '95px', marginBottom: '96px' }}>
						<div className="title">
							<div className="title-text" style={{ fontWeight: 500 }}>
								公司介绍
							</div>
						</div>
						<div className="sub-title">
							<p>{getNameByKey('introComp')}兴趣岛，是一家成立于2016年的文化服务科技品牌，为用户提供多种兴趣学习产品。截至目前，兴趣岛App注册用户3500万+。艾媒认证，兴趣岛已有摄影、太极、瑜伽等涵盖身心健康、传统文化领域的30门主流兴趣课程。</p>
						</div>
					</div>

					<div className="section animateUp" style={{ marginBottom: '120px' }}>
						<div className="title">
							<div className="title-text" style={{ fontWeight: 500 }}>
								主营业务
							</div>
						</div>
						<div className="business img2">
							<div className="common content">
								{/* <h4>千聊特训营</h4> */}
								<h4>兴趣岛兴趣学堂</h4>
								<p>{getNameByKey('introComp')}兴趣岛是一家成立于2016年的文化服务科技公司，为用户提供多种兴趣学习产品。截至目前，兴趣岛App注册用户3500万+。艾媒认证，兴趣岛摄影、瑜伽、太极、养生等30门主流课程内的21门课程学员数量全国第一。</p>
								<p>兴趣岛荣获3届广州市科学技术局授予“广州市未来独角兽创新企业”；2023年联合武当大学堂举办“全民太极节”传承非遗文化，2024年深度联合武当大学堂举办线下太极传承活动；连续三年联合中国摄影报举办“手机摄影大赛”；连续两年受邀成为”中国营养学会“单位会员赋能全民健康。</p>
								{/* <p>通过IP名师教学和助教陪伴的双师模式，对每个课程的知识技能点都配备十年以上专业教研把握课程内容，确保学员从“知道”到“做到”。</p>
								<p>目前千聊特训营开设有兴趣变现、亲子教育、健康变美、时代新职业等类目课程。</p>
								<p>与千聊特训营合作的名师有：东西方占星研究院院长、中美双硕士、职业占星师陈安逸；富士、索尼、尼康特聘摄影讲师潘庆华；中国保健协会减肥分会的体重管理师、NAFC美国国家健康认证协会营养教练田珂等。</p>
								<p>与千聊官方自营合作过的小课程老师有：涵盖职场、理财、亲子、健康，副业，变美，生活，兴趣等20个细分领域。已合作名师：李银河、李静、苏苓、卢勤、大J小D等。</p> */}
								<p>
									<strong>愿景：</strong>成为中国和世界的生活兴趣教育第一品牌。
								</p>
								<p>
									<strong>使命：</strong>让更多人通过知识而获得美好人生。
								</p>
								<p>
									<strong>slogan：</strong>工作陪你半生，兴趣伴你一生。
								</p>
								{/* <p>
									<strong>产品特色：</strong>
									1.名师教学：建立严格考核标准，从专业能力、实战能力、做课能力等9个维度筛选名师大咖，打造高质量教学团队。 2.贴心陪伴：一站式陪伴教学服务，课前多渠道提醒上课，课中名师授课和专业答疑，课后回访跟踪学习效果。 3.精心实效：名师教学和助教陪伴双师模式，十年以上专业教研把握课程内容，帮助学员从知道到做到。 4.高性价比：千元区间学习成本，精品优质课程随时随看，高效在线学习，掌握实用学习技能。
								</p> */}
							</div>
							<div className="common"></div>
						</div>

						<div className="business img1">
							<div className="common"></div>
							<div className="common content">
								<h4>千聊在线教育工具</h4>
								<p>
									<strong>千聊知识工具</strong>&nbsp;&nbsp;全免费，为IP老师、中小知识服务工作者、教培机构提供系统性的经营工具。目前已有200万+讲师进驻千聊，共同服务超过3亿学员。
								</p>
								<p>
									<strong>愿景：</strong>普惠，让有价值的知识可以被人人所拥有。
								</p>
								<p>
									<strong>使命：</strong>致力于做免费可得，让所有人可以免费获取知识的工具和平台。
								</p>
								<p>
									<strong>产品Slogan：</strong>和知识做朋友。
								</p>
								<p>
									<strong>产品特色：</strong>1.技术赋能讲师 作为对第三方开放的工具和平台，千聊知识工具基于个人和中小企业在知识服务、私域运营、营销获客等方面的现实需求，聚合内容创作、裂变获客、营销变现、用户互动、用户管理、数据决策等功能，为B端客户打造一站式、全免费、精私域的知识服务工具，以及可信赖的知识店铺运营解决方案。2.免费慕课课程平台,该项目由千聊公益团队运营，通过千聊工具连接百万以上的知识工作者、职业院校和用工企业，为适龄就业女性提供公益的就业技能培训，并联合阳光妈妈、中国妇女发展基金会等公益组织把培训课程确实送到每一位有就业技能提升诉求的女性手里。培训方向主要包括手工、美业、家政护理、网络营销、厨艺烘焙、收纳整理等有较大就业缺口且女性擅长的职业。
								</p>
							</div>
						</div>
					</div>

					<div className="section intro-ql">
						<h1 className="intro-title">兴趣岛兴趣学堂合作名师</h1>
						<section className="intro-lecturer">
							<h2 className="lecturer-name">一、潘庆华（摄影师、讲师）</h2>
							<div className="intro-item">
								<h3 className="intro-item-title">个人简介</h3>
								<p className="intro-item-contain">潘庆华，男，兴趣岛手机摄影训练营首席讲师，摄影读书会创始人，富士、索尼、尼康、VIVO手机摄影特聘讲师，人民邮电出版社摄影专家顾问。</p>
							</div>
							<div className="intro-item">
								<h3 className="intro-item-title">人物经历</h3>
								<p className="intro-item-contain">潘庆华从1996年开始学习摄影，后建立线上摄影论坛，并开始自主创业，创建“摄影读书会”，教授摄影课程，一直坚持真人出镜+场景化教学的授课方式。</p>
								<p className="intro-item-contain">2021年，潘庆华与兴趣岛合作推出手机摄影训练营课程。这里关于兴趣岛的介绍全部改成：兴趣岛兴趣学堂--名师更多，课程更全。兴趣岛兴趣学堂是腾讯、百度、抖音三大平台教育战略合作伙伴，曾获得腾讯&创新工场等知名机构多轮投资。作为国内领先的兴趣教育品牌，兴趣岛兴趣学堂行业首创用户保障"六不学习公约"、师资标准、教学服务标准和课程打磨标准，为用户提供全领域兴趣成长课程。目前，摄影、瑜伽、营养、养生等30门主流课程21门学员数量全国领先。</p>
								<p className="intro-item-contain">2022年10月21日，千聊手机摄影营年会盛典暨首届手机摄影大赛颁奖礼在广州·凯尔卡顿大酒店顺利举办，潘庆华出席该活动并到场学员进行深度授课。</p>
							</div>
							<div className="intro-item">
								<h3 className="intro-item-title">主要荣誉</h3>
								<p className="intro-item-contain">
									<span className="desc">·</span>
									<strong>VIVO手机人像摄影大赛“人像大师奖”；</strong>
								</p>
								{/* <p className="intro-item-contain">
									<span className="desc">·</span>
									<strong>其出版书籍《非奋斗减肥》当当网时尚美妆类目书籍销量第一名、飙升榜第一名、总榜热卖榜第三名。</strong>
								</p> */}
							</div>
							<div className="intro-item">
								<h3 className="intro-item-title">人物语录</h3>
								<p className="intro-item-contain">帮助更多人通过手机即时发现美、创造美、传播美。</p>
							</div>
						</section>
						<section className="intro-lecturer">
							<h2 className="lecturer-name">二、李在峰（太极老师）</h2>
							<div className="intro-item">
								<div className="intro-item">
									<h3 className="intro-item-title">个人简介</h3>
									<p className="intro-item-contain">李在峰，男，兴趣岛太极营首席讲师，武当玄武派第十四代传人，武当太极养生班总教练，清华大学（深圳）研究生院特约太极老师。</p>
								</div>
								<div className="intro-item">
									<h3 className="intro-item-title">人物经历</h3>
									<p className="intro-item-contain">李在峰自幼于武当修文习武，受多位武当名师教导。</p>
									<p className="intro-item-contain">
										<span className="desc">·</span>
										2003年，受邀带队在上海世博会演出。
									</p>
									<p className="intro-item-contain">
										<span className="desc">·</span>
										2005年，往北京人民大会堂与全球大使交流表演。
									</p>
									<p className="intro-item-contain">
										<span className="desc">·</span>
										2009年，受新加坡总统纳丹阁下特邀，赴新加坡总统府交流养生功法，并受到总统纳丹、总理李显龙的接见。
									</p>
									<p className="intro-item-contain">
										<span className="desc">·</span>
										2011年，参与拍摄道教纪录片《太和武当》，出演主角。
									</p>
									<p className="intro-item-contain">
										<span className="desc">·</span>
										2016年，响应国家号召《武术走进校园》《健康中国》公益行全国巡回授课，受益者近十万余人。
									</p>
									<p className="intro-item-contain">
										<span className="desc">·</span>
										2022年，《少年中国说》特邀嘉宾。
									</p>
									<p className="intro-item-contain">
										<span className="desc">·</span>
										2022年12月，与兴趣岛合作推出《逆龄养生太极营》、《养元活血太极营》，深受学员的好评。与其合作的这里关于兴趣岛的介绍全部改成：兴趣岛兴趣学堂--名师更多，课程更全。兴趣岛兴趣学堂是腾讯、百度、抖音三大平台教育战略合作伙伴，曾获得腾讯&创新工场等知名机构多轮投资。作为国内领先的兴趣教育品牌，兴趣岛兴趣学堂行业首创用户保障"六不学习公约"、师资标准、教学服务标准和课程打磨标准，为用户提供全领域兴趣成长课程。目前，摄影、瑜伽、营养、养生等30门主流课程21门学员数量全国领先。
									</p>
								</div>
								<div className="intro-item">
									<h3 className="intro-item-title">主要荣誉</h3>
									<p className="intro-item-contain">
										<span className="desc">·</span>
										<strong>2008年，荣获武当杯长枪冠军，八极拳冠军；</strong>
									</p>
									<p className="intro-item-contain">
										<span className="desc">·</span>
										<strong>2018年8月，荣获香港国际武术节比赛，长枪冠军，太极拳，太极剑，冠军，团体第一名。</strong>
									</p>
								</div>
							</div>
						</section>
						<section className="intro-lecturer">
							<h2 className="lecturer-name">三、石今如（中医变美老师）</h2>
							<div className="intro-item">
								<div className="intro-item">
									<h3 className="intro-item-title">个人简介</h3>
									<p className="intro-item-contain">石今如（真名：石晓，网名：二妹姐），女，<strong>兴趣岛中医变美训练营首席讲师</strong>，中医美容专家兼高级艾灸师，作为养生导师参与过《美丽俏佳人》的拍摄，第一届中华芳香制作协会荣誉顾问，中医健康高级管理师，著有畅销书《香艾是最好的疗愈》，深入研究中医养生十几年，在养生保健方面具有深厚的理解和实践经验。现任北京二妹姐科技有限公司董事长，作为艾灸和芳香疗法结合之路上的探索者，她将艾灸与芳香疗法融合，独创了与众不同的香艾疗法，以平衡女性的身心健康。</p>
								</div>
								<div className="intro-item">
									<h3 className="intro-item-title">人物经历</h3>
									<p className="intro-item-contain">
										石今如坚持十多年中医保健与女性逆龄健康的研究、传承与实践。
									</p>
									<p className="intro-item-contain">1.2010年受邀参加阿曼与中国建交40周年活动。石今如深度研究芳疗护肤，作为乳香精油传播大使曾在阿曼受到阿曼小王子接待。她称，精油作为西方的中草药，芳香护肤和中医美容有异曲同工之妙，都是沿经络而行，帮助人体防病和美容。</p>
									<p className="intro-item-contain">2.2015年石今如开设一档名为《女人都爱养生》的节目，分享自己的养生知识和经验。该节目迅速获得了广大听众的喜爱和支持，不到两年时间就吸引了超过400万的粉丝。此外，石今如还涉足了艾灸和芳香疗法领域，致力于结合这两种传统治疗方法，提供有益于身心的健康解决方案。</p>
									<p className="intro-item-contain">3.2018年出版畅销书籍《香艾是最好的疗愈》，豆瓣评分高达9.2，深受无数读者喜爱。</p>
									<p className="intro-item-contain">4.2019年作为节目《美丽俏佳人》的特约养生导师,参加节目录制。</p>
									<p className="intro-item-contain">5.2019年,石今如前往日本台湾各地做逆龄抗衰产品的深度调研。</p>
									<p className="intro-item-contain">6.2019年,石今如的中医抗衰专辑《宫廷美颜术》登录北京地铁各大站线，为市民滚动传播中医抗衰理念。</p>
									<p className="intro-item-contain">7.2022年，石今如与一众知名健康专家受邀南方健康4周年系列活动——《健谈》直播研讨，与十几位健康传播大咖进行3小时全方位交流。</p>
									<p className="intro-item-contain">8.<strong>2024年1月，与兴趣岛中医变美训练营合作推出《28天面部轮廓抗衰营》，深受学员的好评。</strong></p>
								</div>
							</div>
						</section>
						<section className="intro-lecturer">
							<h2 className="lecturer-name">四、陈浙南【兴趣岛中医瑜伽首席讲师】</h2>
							<div className="intro-item">
								<div className="intro-item">
									<h3 className="intro-item-title">个人简介</h3>
									<p className="intro-item-contain">陈浙南，男，浙江绍兴人，中医瑜伽体系创始人，太极禅灸创始人，兴趣岛中医瑜伽首席讲师。他是国学大师南怀瑾、中医大家赖世伦亲传弟子，是一带一路国际瑜伽大会特约授课导师。他有着近20年身体疼痛理疗经验，14年线下瑜伽馆教学经验。他将中医与瑜伽融合，独创“中医瑜伽-体位即是药”运动治病养生方式，至今（2024年）已帮助100万+家庭重获健康。</p>
									<p className="intro-item-contain">为之于民，举而措之！陈老师深入研习和教学中医瑜伽数十年，致力推动“健康中国行动”，主张“体位即是药”、“身体自带大药房”，倡导国民做自己和家庭的“保健师”。</p>
									<p className="intro-item-contain">
										<img src="https://img.qlchat.com/qlLive/activity/image/RJM398V7-RYJ6-Z4OK-1716201674585-7H8J4NJOHD2N.png" />
									</p>
								</div>
								<div className="intro-item">
									<h3 className="intro-item-title">人物经历</h3>
									<p className="intro-item-contain">1.初中时期，陈浙南老师在运动方面天赋异禀，酷爱体育，学习国际自由式摔跤，梦想当一名摔跤教练。</p>
									<p className="intro-item-contain">2.高考失利后，与瑜伽结缘，发现瑜伽的运动疗养功效并热爱，勤学苦练，不断深入，并遍寻名师学习更系统更高阶的课程。</p>
									<p className="intro-item-contain">3.2011年，开设第一家瑜伽馆，深受广大会员喜爱。但他发现来练瑜伽的人，除了强身健体，她们总会苦恼于有各种各样的身体病痛问题无法解决，于是陈浙南很想帮助他们并找寻解决之法。</p>
									<p className="intro-item-contain">4. 2013年，拜师韩国瑜伽第一人金利眩先生，勤学苦练瑜伽功法。发现瑜伽还是不能解决多数人的病痛。</p>
									<p className="intro-item-contain">5. 2014年，33岁的他遍寻名医，走进百草箱，师从中医大家赖世伦（师父系国学大师南怀瑾）学传统中医，在其影响下立志、真修、实悟、做明人，投身于中医传承事业，并持续研习将瑜伽与中医融合。</p>
									<p className="intro-item-contain">6. 2016年，荣获“瑜伽之爱”的“优秀瑜伽教练”称号。</p>
									<p className="intro-item-contain">7. 2017年，获得波士顿回归中医药大学三年制中医学结业证书。</p>
									<p className="intro-item-contain">8. 2018年，他在一带一路国际瑜伽大会正式提出中医瑜伽体系。他独家的“一分钟身体去痛疗法”技惊四座，引得媒体竞相报道。  </p>
									<p className="intro-item-contain">9. 2019年，获得第五届“瑜伽之爱”年度盛典委员会“瑜伽理疗师”称号，获得天津市蓟州区体育局二级裁判员证。</p>
									<p className="intro-item-contain">10. 2019年，师从贵州名医、贵州中医药大学硕士生导师、中国名老中医黄琴老师学习经方。</p>
									<p className="intro-item-contain">11. 2020年，获得北京“瑜伽之爱”考评中心颁发的“健身瑜伽六段”证书。</p>
									<p className="intro-item-contain">12. 2023年，师从中央保健局原特聘正骨专家——吴石华教授，学习北派按摩和正骨手法。</p>
									<p className="intro-item-contain">13. 2021年，获得蚌埠市健康委员会颁发的“针灸推拿专长技术考核合格证”。</p>
									<p className="intro-item-contain">14. 2023年，为让中医瑜伽造福更多人，成为兴趣岛中医瑜伽首席讲师。与其合作的兴趣学堂是国内生活和兴趣爱好学习平台，作为国内兴趣教育品牌，已有千位名师和千种兴趣课程，全面升级学员保障"六不公约"、师资标准、教学服务标准和课程打磨标准，为用户提供全领域兴趣成长课程，30大主流课程21门学员数量全国领先。</p>
								</div>
								<div className="intro-item">
									<h3 className="intro-item-title">【陈浙南与中医瑜伽的故事】</h3>
									<h3 className="intro-item-title">“为之于民，举而措之”——初心既定，行以致远</h3>
									<p className="intro-item-contain">“浙南啊，我们这一世短短的几十年，到底要做一个什么事情？我们做的这个事情对国家、对民族，乃至世界人类有什么好处？”——赖世伦先生</p>
									<p className="intro-item-contain">每每回忆起恩师赖世伦，陈浙南都感怀许久。自2014年走进百草箱进行3年的传统中医学习，至今已10年整了。百草箱是赖世伦先生受南怀瑾先生感召回国创办的。在百草箱的学习，让陈浙南建立了传承中医、真修育明人的初心。要把好的资产奉献给人类，奉献给社会，奉献给我们的国家。</p>
									<p className="intro-item-contain">
										<img src="https://img.qlchat.com/qlLive/activity/image/TMS6GPB2-9RXQ-FGOM-1716197256408-8LW3Z9PP5I3H.png" />
									</p>
									<p className="intro-item-contain">（三代传承中医文化）</p>
									<p className="intro-item-contain">“为之于民，举而措之”，成为陈浙南印在心里的发心，成为他后来认定的一辈子生命价值的所在。</p>
									<p className="intro-item-contain">中医瑜伽这个体系是陈浙南在2018年一带一路国际瑜伽大会上正式对外提出的。这是一个以中国传统医学思维和实践经验为指导的瑜伽体系。它涵盖了传统中医的六艺：导引、按跷、砭石、针、灸、汤药（食疗），是适合中国人自己的瑜伽养生防病体系。得益于师公南怀瑾和赖师的口授和传承，为适应后进学者修习领悟，他十分认同这四句立为中医瑜伽后进学者修学之本：不是学校的学校，不是医院的医院，不是医生的医生，不是道场的道场！</p>
									<p className="intro-item-contain">中医瑜伽的强大魅力所在即主张“体位即是药”，通过学习中医自诊、瑜伽导引体式的方法，启动身体大药房，让人们做自己和家庭的“保健师”，治已病，防未病，提高生命质量。</p>
									<p className="intro-item-contain">他深入研习和教学中医瑜伽数十年，孜孜不倦，践行初心。时至今日，陈浙南已用中医瑜伽这套治病养生方式，帮助了100万+家庭重获健康。</p>
								</div>
								<div className="intro-item">
									<h3 className="intro-item-title">与瑜伽结缘，热爱并擅长</h3>
									<p className="intro-item-contain">陈浙南与瑜伽的缘分像使命使然，像命中注定。</p>
									<p className="intro-item-contain">陈浙南出生于浙江县城的一个普通家庭，爱运动并且在体育方面天赋异禀。因为体育特长一路保送。在初中时期，他学习国际自由式摔跤，当时他的第一个梦想是当一名摔跤教练。但高考失利后，梦想之火熄灭。高中毕业后，年少的他开始在社会孤独地打拼。</p>
									<p className="intro-item-contain">也许是心底一种与生俱来的不安全感和不甘心在社会做着自己不喜欢的看不到头的工作，他一直保持学习的动力，求知若渴，拼命买书，不断往自己感兴趣的领域摸索和努力。</p>
									<p className="intro-item-contain">勤学肯干的他百般求索终于找到了自己的兴趣所在——瑜伽。瑜伽满足了他运动的爱好，又让他意识到之前身体过度体育训练造成损伤的修补之法，也发现瑜伽可以帮助他人的奥妙。</p>
									<p className="intro-item-contain">进入瑜伽学习之后，随着不断深入，他想要更系统更进阶地研习瑜伽。于是，陈浙南老师寻访并拜国际瑜伽名师为师，勤勉刻苦。他十年如一日的学习，每天4、5个小时练习瑜伽，在他30岁那年开了第一家瑜伽馆。后来，第2家、第3家……</p>
								</div>
								<div className="intro-item">
									<h3 className="intro-item-title">解学员之忧，苦学中医</h3>
									<p className="intro-item-contain">随着学员越来越多，瑜伽馆越开越多，陈浙南发现来练习瑜伽的人，除了强身健体，她们总会苦恼于有各种各样的身体病痛问题无法解决。老师很想帮到她们，在33岁那年，命运让他结识了贵州名老中医——赖世伦老师。</p>
									<p className="intro-item-contain">从2014年开始，陈浙南老师开始跟着赖世伦老师日夜学习中医，那时，陈浙南经常学习结束后便直接住在了赖师家中，以便方便次日学习。这样勤学又诚心修行的学生自然得到赖师的格外青睐。陈浙南不仅学习到传统中医的医理技术，也吸收了中医传承国学大师南怀瑾和赖世伦老师的教学理念。初心既定，行以致远。与赖老师的相遇，可谓是陈浙南逆袭的起点。</p>
									<p className="intro-item-contain">除了学习赖师的精髓，陈浙南也修习中医其他相关特长技术。2017年，他获得波士顿回归中医药大学三年制中医学结业证书；2019年，师从贵州名医、贵州中医药大学硕士生导师、中国名老中医黄琴老师学习经方；2023年，师从中央保健局原特聘正骨专家——吴石华教授学习北派按摩和正骨手法......</p>
								</div>
								<div className="intro-item">
									<h3 className="intro-item-title">始创中医瑜伽，“体位即是药”</h3>
									<p className="intro-item-contain">说来这一路走来也颇不容易，陈浙南花了10年的时间潜心钻研，独创了一套适合中国人体质的「中医瑜伽—养生防病体系」，于2018年一带一路国际瑜伽大会上首次提出。</p>
									<p className="intro-item-contain">中医瑜伽结合了赖老师平日教授的养生功法和心法，将印度瑜伽中的体式动作、根据中医十四正经循行分经归类。使学者通过手法触诊诊察经络变动和人迎寸口按脉比较人体阴阳气血偏差，最后运用瑜伽体位导引恢复人体气血平衡。</p>
									<p className="intro-item-contain">中医瑜伽主张“体位即是药”、“身体是个大药房”，陈浙南通过“特定设计的瑜伽体位法”进行导引，就可以将身体的气血精准引导到该淤堵部位，指哪打哪，就可以疏通经络，达到缓解病症、趋于健康的效果，解决了很多人的亚健康、慢性疾病，长期练习可改善体质养成健康体质。</p>
									<p className="intro-item-contain">为让中医瑜伽成为更多人的一种健康生活方式，2023年，陈浙南结缘兴趣岛，成为兴趣岛中医瑜伽首席讲师，搭上线上兴趣教育的平台为更多人传递中医瑜伽的魅力。线上线下多面教学，陈浙南和他首创的中医瑜伽的影响力越来越大。怀揣初心的他始终在中医瑜伽的道路上孜孜前行、精进不怠，不断为中医瑜伽的发展贡献自己的力量。</p>
								</div>
								<div className="intro-item">
									<h3 className="intro-item-title">【中医瑜伽】</h3>
									<h3 className="intro-item-title">一、中医瑜伽概念</h3>
									<p className="intro-item-contain">中医瑜伽是指以传统中医学理论和实践为指导，精准探查人体失衡的经筋和经络，运用瑜伽体位引导人体气血归于平衡，从而达到祛病强身的作用。</p>
									<p className="intro-item-contain">中医瑜伽体系由陈浙南老师于2018年在一带一路国际瑜伽大会上正式提出。中医瑜伽运用经络触诊，人迎寸口脉诊等中医诊察辨症的方法精准定位有问题的筋络，用瑜伽体式作药，启动人体与生俱来的大药房，治已病，防未病。</p>
									<p className="intro-item-contain">
										<img src="https://img.qlchat.com/qlLive/activity/image/XZLSPGFF-JOEA-PZTZ-1716197683105-6DSQDL9MOPZ5.png" />
									</p>
									<p className="intro-item-contain">（陈浙南老师）</p>
								</div>
								<div className="intro-item">
									<h3 className="intro-item-title">二、中医瑜伽的特点</h3>
									<p className="intro-item-contain">1.病脉证治，体位即是药</p>
									<p className="intro-item-contain">【病】——根据症状判断变异经络</p>
									<p className="intro-item-contain">【脉】——人迎寸口脉对比，再次确定变异经络</p>
									<p className="intro-item-contain">【证】——循经诊查确定变异经络所在位置</p>
									<p className="intro-item-contain">【治】——用瑜伽体位法导引气血和中医六艺恢复阴阳气血平衡</p>
									<p className="intro-item-contain">2.舌诊</p>
									<p className="intro-item-contain">舌诊是中医望诊重要内容，是指观察舌头的色泽、形态的变化来辅助诊断及鉴别体质和问题。</p>
									<p className="intro-item-contain">根据舌象状态，人大致可以分为八大类的亚健康体质。不同的体质有不同的舌相特点。中医瑜伽主张通过舌相快速辩证身体问题，结合瑜伽体式和中医六艺，开出不同的调理方案，并跟踪舌相变化做调理反馈。</p>
								</div>
								<div className="intro-item">
									<h3 className="intro-item-title">三、练习中医瑜伽的好处</h3>
									<p className="intro-item-contain">“体位即是药，身体自带大药房”！中医瑜伽强调用中医医理融合瑜伽体式启动身体大药房，启动人体与生俱来的气血工厂——三焦系统，缓解已病，改善体质，进而开启防病体系，抗衰逆龄。中医瑜伽强调身心同调，精神内守，长期练习还可疗愈身心，解决情绪问题、关系问题，自医享福，大大提高生命质量。练习中医瑜伽好处很多，具体说来可以具体分为：</p>
									<p className="intro-item-contain">1.清理身体垃圾，疏通筋络，解决肩背僵硬、手脚凉、头晕、心肺失调问题</p>
									<p className="intro-item-contain">2.调理脾胃，可有效解决容易发胖、三高、长结节的问题</p>
									<p className="intro-item-contain">3.打通下焦，解决脸色黄、睡眠差问题，延缓衰老</p>
									<p className="intro-item-contain">4.调顺气机，改善气色、改善肠胃功能、解决排便等诸多问题</p>
									<p className="intro-item-contain">5.掌握养精血经络医理，练习相对应的瑜伽体式，可更好地抗衰逆龄、美体回春</p>
									<p className="intro-item-contain">6.长期系统练习，可进一步缓解腰椎疼痛，启动自身大药房，提高免疫力开启防病系统</p>
									<p className="intro-item-contain">7.掌握独家疼痛理疗、中医流运动，达到快速止痛的作用</p>
									<p className="intro-item-contain">8.学习国学养生，顺道养生，身心同调，告别结节，凝神静气，达到疗愈身心，自医自愈</p>
									<p className="intro-item-contain">......</p>
								</div>
								<div className="intro-item">
									<h3 className="intro-item-title">四、中医瑜伽的缘起与流行</h3>
									<p className="intro-item-contain">中医瑜伽的概念由陈浙南老师率先提出。2018年，中医瑜伽体系由陈浙南老师在一带一路国际瑜伽大会上正式提出。中医瑜伽体系从诞生到传播盛行，耗费了陈浙南老师数十年的心血，也经历了长时间的实践与检验。</p>
									<p className="intro-item-contain">首先，陈浙南老师是一个精通瑜伽并有数十年瑜伽教学经验的人，他从高中毕业后就酷爱瑜伽，遍寻瑜伽大师练习多年后，在2011年便开设了第一家瑜伽馆，学员众多，甚受欢迎，于是不断开设第2家、第3家......慢慢地，他发现来练瑜伽的人，除了强身健体，她们总会苦恼于有各种各样的身体病痛问题无法解决，于是陈浙南很想帮助他们并找寻解决之法。</p>
									<p className="intro-item-contain">在瑜伽的研习上，陈浙南老师孜孜不倦、不断进阶。2013年，他拜师韩国瑜伽第一人金利眩先生，勤学苦练瑜伽功法。</p>
									<p className="intro-item-contain">无论他把瑜伽研习到哪种境界，都无法解决很多瑜伽学员的身体疼痛疾病。陈浙南很想帮助她们！</p>
									<p className="intro-item-contain">于是，百般求索，陈浙南老师在2014年，走进百草箱，师从中医大家赖世伦（师父系国学大师南怀瑾）学传统中医，深得中医医理之精妙。在百草箱的学习，让陈浙南建立了传承中医、真修育明人的初心——要把好的资产奉献给人类，奉献给社会，奉献给我们的国家。“为之于民，举而措之”，成为陈浙南印在心里的发心，成为他后来认定的一辈子生命价值的所在。</p>
									<p className="intro-item-contain">除了学习赖师的精髓，陈浙南也修习中医其他相关特长技术。2017年，他获得波士顿回归中医药大学三年制中医学结业证书；2019年，师从贵州名医、贵州中医药大学硕士生导师、中国名老中医黄琴老师学习经方；2023年，师从中央保健局原特聘正骨专家——吴石华教授学习北派按摩和正骨手法......</p>
									<p className="intro-item-contain">中医瑜伽体系是一套适合中国人体质的「养生防病体系」， 陈浙南老师花了10年的时间潜心钻研。中医瑜伽结合了中医大家赖世伦老师平日教授的养生功法和心法，将印度瑜伽中的体式动作、根据中医十四正经循行分经归类。使学者通过手部触诊诊察经络变动和人迎寸口按脉比较人体阴阳气血偏差，最后运用瑜伽体位导引恢复人体气血平衡。</p>
									<p className="intro-item-contain">中医瑜伽主张“体位即是药”、“身体是个大药房”，陈浙南老师通过“特定设计的瑜伽体位法”进行导引，就可以将身体的气血精准引导到该淤堵部位，指哪打哪，就可以疏通经络，达到缓解病症、趋于健康的效果，解决了很多人的亚健康、慢性疾病，长期练习改善了体质养成健康体质。</p>
									<p className="intro-item-contain">2023年，陈浙南结缘兴趣岛，成为兴趣岛中医瑜伽首席讲师。他合作的兴趣学堂是国内生活和兴趣爱好学习平台，作为国内兴趣教育品牌，已有千位名师和千种兴趣课程，全面升级学员保障"六不公约"、师资标准、教学服务标准和课程打磨标准，为用户提供全领域兴趣成长课程，30大主流课程21门学员数量全国领先。</p>
									<p className="intro-item-contain">开启线上线下多面教学，陈浙南和他首创的中医瑜伽的影响力越来越大，至今已帮助100万+家庭重获健康。坚定初心的他始终在中医瑜伽的道路上孜孜前行、精进不怠，不断为中医瑜伽的发展贡献自己的力量，把中医瑜伽的好处惠及更多的人。</p>
								</div>
							</div>
						</section>
						<section className="intro-lecturer">
							<h2 className="lecturer-name">五、周航（兴趣岛道家养生首席讲师）</h2>
							<div className="intro-item">
								<div className="intro-item">
									<h3 className="intro-item-title">人物简介</h3>
									<p className="intro-item-contain">周航，字航君，男，湖北武汉人。</p>
									<p className="intro-item-contain">道家养生修真文化教育者，辟谷及导引养生传播者，现任兴趣岛道家养生首席讲师。</p>
									<p className="intro-item-contain">全真龙门派第十五代丹道传人，武当和式太极第十三代传人，师承胡耀贞大师弟子。</p>
									<p className="intro-item-contain">资深健康管理师、国家二级心理咨询师。</p>
								</div>
								<div className="intro-item">
									<h3 className="intro-item-title">人物经历</h3>
									<p className="intro-item-contain">2005 年，周航正式投身健康教育领域。</p>
									<p className="intro-item-contain">2006年 创业建立至真养生本源文化传播工作室。</p>
									<p className="intro-item-contain">2007年 正式开启养生文化及技术的相关培训班。</p>
									<p className="intro-item-contain">2009年 华中科技大学文华学院特聘为公共课讲师。</p>
									<p className="intro-item-contain">2011年 养生课程教培体系全面完善。</p>
									<p className="intro-item-contain">集合道家吐纳、经络、太极、瑜伽等传统养生文化项目导入到健康管理概念中，以提升能量为核心功能的课程定位，倡导辅助养生新概念。于全国各地定期举办，培训学员涉及医疗、卫生、保健等多个行业领域。</p>
									<p className="intro-item-contain">2012年 成立企业健康管理咨询服务中心。</p>
									<p className="intro-item-contain">针对企事业单位员工提供特色健康评估、健康讲座、办公室亚健康自助康复服务、EAP（员工心理援助）计划等服务。</p>
									<p className="intro-item-contain">2013年 创建深蓝海生命研修会身心灵学习平台。</p>
									<p className="intro-item-contain">打造热爱探索生命科学的社会精英交流平台，整合并研发生命科学相关领域，包括养生学、哲学、心理学、道学、禅学，为社会大众及企事业单位组织各类禅修疗愈课程、心灵成长培训讲座及游学活动等。</p>
									<p className="intro-item-contain">2015年 受邀湖北电视台，生活频道记者专题采访道家辟谷养生。</p>
									<p className="intro-item-contain">2017年 武汉广播电台特邀嘉宾老师，访谈道家养生之辟谷术。</p>
									<p className="intro-item-contain">2018年 受邀于湖北省非遗文化研究中心，成立传统道家养生研究小组，参与有关辟谷养生的学术科研及实验。</p>
									<p className="intro-item-contain">美国AAPMR2015康养年会受邀嘉宾。</p>
									<p className="intro-item-contain">中国康复学会专业委员会物理治疗学术论坛代表。</p>
									<p className="intro-item-contain">首届中国传统文化与与系统排列高峰论坛嘉宾。</p>
									<p className="intro-item-contain">受邀于《瑜伽》杂志约稿，发表道家养生文化专题论文。</p>
									<p className="intro-item-contain">首届国际青年瑜伽大会受邀嘉宾老师。</p>
									<p className="intro-item-contain">第二届西湖国际瑜伽论坛暨艺术节受邀嘉宾，道家养生专题报告。</p>
									<p className="intro-item-contain">首届亚洲瑜伽经管峰会受邀嘉宾老师。</p>
									<p className="intro-item-contain">历届中国瑜伽生活周特邀嘉宾老师。</p>
								</div>
							</div>
						</section>
					</div>

					{/* <div className="section animateUp" style={{ marginBottom: '80px' }}>
						<div className="title">
							<div className="title-text" style={{ fontWeight: 500 }}>
								发展历程
							</div>
						</div>
						<div className="progress">
							<div className="common left">
								<p>2016.03</p>
								<h5>公司成立</h5>
								<span>获得欢聚时代（YY）创始人李学凌战略天使轮投资。</span>
								<span>上线付费话题功能，是微信生态内最早提出“直播付费知识”概念的平台。</span>
							</div>
							<div className="common right">
								<p>2017.06</p>
								<h5>举办知识付费行业峰会</h5>
								<span>奠定知识付费行业领先地位。</span>
							</div>
							<div className="common left">
								<p>2017.10</p>
								<h5>获得腾讯投资部和腾讯双百计划的千万级人民币A+轮追加融资。</h5>
							</div>
							<div className="common right">
								<p>2018.07</p>
								<h5>宣布正式进攻内容领域</h5>
								<span>服务2亿用户，成为一家S2B2C的知识服务平台。</span>
							</div>
							<div className="common left">
								<p>2018.11</p>
								<h5>举办「首届中国女性知识服务行业峰会」</h5>
								<span>奠定国内女性知识服务行业领先地位。</span>
							</div>
							<div className="common right">
								<p>2019.01</p>
								<h5>获得B轮过亿元投资</h5>
								<span>由知名投资机构创新工场投资，估值超过十亿元人民币。</span>
							</div>
							<div className="common left">
								<p>2020.05</p>
								<h5>推出效果化的教育类课程，包含少儿项目荷小鱼。</h5>
							</div>
							<div className="common right">
								<p>2021.05</p>
								<h5>正式推出高品质的成人教育项目「千聊特训营」，slogan：从知道到做到。</h5>
							</div>
							<div className="common left">
								<p>2022.01</p>
								<h5>千聊特训营品牌升级</h5>
								<span>提出新slogan：发现我的能量。</span>
							</div>
						</div>
					</div> */}
					<div className="section animateUp" style={{ marginTop: '95px', marginBottom: '96px' }}>
						<div className="title">
							<div className="title-text" style={{ fontWeight: 500 }}>
								企业社会价值
							</div>
						</div>
						<div className="sub-title">
							<p>2020年，联合人民网慕课共同发起“致敬·知识行业领路人”活动，促进知识付费行业良性发展。</p>
							<p>2020年，疫情期间，发起「十万在线教室计划」，为全国教育工作者免费提供线上开课工具和7*12h运营支持；活动期间，累计为超过800万学员恢复课业。</p>
							<p>2021年，为浙江省考试院主办的高考志愿填报“云咨询周”公益活动，提供直播技术支持，为超10万名考生和家长提供视频直播宣讲，总观看人次超48万。</p>
							<p>2021年，为湖北省商务厅“抗疫扶农”公益培训活动，提供直播技术支持，覆盖数万名农村电商人，有效发掘与培训更多电商人才。</p>
							<p>2021-2022年，加入腾讯教育公益计划「UP职计划」，为乡村青年、残障人士提供免费新职业培训，助推教育资源普惠发展。</p>
						</div>
					</div>
					<div className="section animateUp" style={{ marginBottom: '96px' }}>
						<div className="title">
							<div className="title-text" style={{ fontWeight: 500 }}>
								所获荣誉
							</div>
						</div>
						<div className="honor">
							<div className="head">
								<img src="https://img.qlchat.com/qlLive/activity/image/ZCCJ3YOJ-LDG6-TXGH-1600335841676-ERTYEBGJX28Y.jpg?x-oss-process=image/format,webp" />
							</div>
							<div className="list">
								<img src="https://img.qlchat.com/qlLive/activity/image/3YB8WNM5-1N27-XQGM-1652349568930-RNBB34HP31NT.png?x-oss-process=image/format,webp" alt="" />
								<img src="https://img.qlchat.com/qlLive/activity/image/WI5MOJE8-GL46-5D9Q-1652349555458-3YVUBSP3VV9R.png?x-oss-process=image/format,webp" alt="" />
								<img src="https://img.qlchat.com/qlLive/activity/image/FILS2KYV-P445-PBLK-1652349561597-RXW2B26PXEB1.png?x-oss-process=image/format,webp" alt="" />
								<img src="https://img.qlchat.com/qlLive/activity/image/FS94BPPB-TS95-4J6P-1652349566396-2QEEXP37R8I7.png?x-oss-process=image/format,webp" alt="" />
							</div>
							<div className="list">
								<img src="https://img.qlchat.com/qlLive/activity/image/JYQLLPAD-GTVR-IQ7V-1600335503594-J3CFCUUDBB5A.jpg?x-oss-process=image/format,webp" alt="" />
								<img src="https://img.qlchat.com/qlLive/activity/image/9LF3E4WO-UI38-5X62-1600335508485-M351P2I3PN9F.jpg?x-oss-process=image/format,webp" alt="" />
								<img src="https://img.qlchat.com/qlLive/activity/image/GAXJP34V-43Q3-PK88-1600335513775-8E3UDWU26UPZ.jpg?x-oss-process=image/format,webp" alt="" />
								<img src="https://img.qlchat.com/qlLive/activity/image/8PFKM8FC-4FFZ-4ABC-1600335520314-IM4JR9L1ESIK.jpg?x-oss-process=image/format,webp" alt="" />
							</div>
							<div className="list">
								<img src="https://img.qlchat.com/qlLive/activity/image/2HMJFK3P-PGW4-H3DO-1600335527526-7IM8LVYSTV91.jpg?x-oss-process=image/format,webp" alt="" />
								<img src="https://img.qlchat.com/qlLive/activity/image/BRW62OCU-49RK-5ZQS-1600335532744-FMCMUTBMPR6B.jpg?x-oss-process=image/format,webp" alt="" />
								<img src="https://img.qlchat.com/qlLive/activity/image/5AUNIN91-XN2D-YSQC-1600335537569-O5EBV1QJB6TM.jpg?x-oss-process=image/format,webp" alt="" />
								<img src="https://img.qlchat.com/qlLive/activity/image/DNH2YSN7-VJ6Q-IFQ8-1600335542377-GKMPH819B9UC.jpg?x-oss-process=image/format,webp" alt="" />
							</div>
							<div className="list">
								<img src="https://img.qlchat.com/qlLive/activity/image/9J6HP4FP-ILBT-IWRK-1600335550988-MPCBR9HMBXVU.jpg?x-oss-process=image/format,webp" alt="" />
								<img src="https://img.qlchat.com/qlLive/activity/image/Q9VW2W6A-RZ4W-LNOF-1600335558827-YLYEZMHSONPM.jpg?x-oss-process=image/format,webp" alt="" />
								<img src="https://img.qlchat.com/qlLive/activity/image/RTE8HLIT-A4O7-FQYZ-1600335563626-C6YYAYDXMIH2.jpg?x-oss-process=image/format,webp" alt="" />
								<img src="https://img.qlchat.com/qlLive/activity/image/P46Q8NQB-NXOS-AJCD-1600335569186-VGX2VK423THM.jpg?x-oss-process=image/format,webp" alt="" />
							</div>
							<div className="list">
								<img src="https://img.qlchat.com/qlLive/activity/image/2R1O57AL-2235-44P5-1600335728155-3XOD2DBAUEQ4.jpg?x-oss-process=image/format,webp" alt="" />
								<img src="https://img.qlchat.com/qlLive/activity/image/BIFVMIC1-O467-CR3L-1600335732293-U1XT1GLDKSWQ.jpg?x-oss-process=image/format,webp" alt="" />
								<img src="https://img.qlchat.com/qlLive/activity/image/93JDF941-WAMZ-8MTI-1600335778899-7111FZBTG9IG.jpg?x-oss-process=image/format,webp" alt="" />
								<img src="https://img.qlchat.com/qlLive/activity/image/UH88HR3Q-IHOD-LW7K-1600335783682-V6YSE5ERN5CL.jpg?x-oss-process=image/format,webp" alt="" />
							</div>
						</div>
					</div>
					<div className="section intro-ql">
						<h1 className="intro-title">兴趣岛兴趣学堂品牌介绍</h1>
						<section className="intro-lecturer">
							<h2 className="lecturer-name">一、品牌介绍</h2>
							<div className="intro-item">
								<p className="intro-item-contain">
									<p className="intro-item-contain">兴趣岛，{getNameByKey('introComp')}教育品牌。兴趣岛兴趣学堂，是腾讯百度抖音三大平台教育战略合作伙伴，曾获得腾讯等知名机构多轮投资。作为国内领先的兴趣教育品牌，兴趣岛兴趣学堂全面升级学员保障"六不公约"、师资标准、教学服务标准和课程打磨标准，为用户提供全领域兴趣成长课程。目前，摄影、瑜伽、营养、养生等30门主流课程21门学员数量全国领先。</p>
									<p className="intro-item-contain">兴趣岛兴趣学堂倡导“好课良师益友”的理念，受到中国家庭教育学会、中国心理协会等多家权威单位认可，获得腾讯、百度、360等颁发“用户最认可品牌”，并成为“中国营养学会”会员单位。</p>
								</p>
							</div>
						</section>
						<section className="intro-lecturer">
							<h2 className="lecturer-name">二、品牌文化</h2>
							<div className="intro-item">
								<p className="intro-item-contain">愿景：成为中国和世界的生活兴趣教育第一品牌</p>
								<p className="intro-item-contain">使命：让更多人通过学习而带来美好生活</p>
								<p className="intro-item-contain">品牌标语：名师更多，课程更全</p>
								<p className="intro-item-contain">品牌定位：国内领先的兴趣教育品牌</p>
							</div>
						</section>
						<section className="intro-lecturer">
							<h2 className="lecturer-name">三、品牌特色</h2>
							<div className="intro-item">
								<h3 className="intro-item-title">1、六不学习公约</h3>
								<p className="intro-item-contain">① 不名师，不开课；</p>
								<p className="intro-item-contain">② 不满意，可换课；</p>
								<p className="intro-item-contain">③ 不放水，每课十道工；</p>
								<p className="intro-item-contain">④ 不套路，如老友相处；</p>
								<p className="intro-item-contain">⑤ 不走心，可换班主任；</p>
								<p className="intro-item-contain">⑥ 不内卷，快乐陪伴温馨。</p>
							</div>
							<div className="intro-item">
								<h3 className="intro-item-title">2、六大课程特色</h3>
								<p className="intro-item-contain">① 入门正，名师授课学名门正宗；</p>
								<p className="intro-item-contain">② 学得快，专业工序磨课节奏明；</p>
								<p className="intro-item-contain">③ 效果强，百里挑一得独家方法；</p>
								<p className="intro-item-contain">④ 很上瘾，体系环环相扣有心流；</p>
								<p className="intro-item-contain">⑤ 真价值，兴趣变能力改变生活；</p>
								<p className="intro-item-contain">⑥ 交学友，志趣结交交流有温度。</p>
							</div>
							<div className="intro-item">
								<h3 className="intro-item-title">3、选取名师五项基本指标</h3>
								<p className="intro-item-contain">① 从业时长：10年</p>
								<p className="intro-item-contain">② 具备行业顶尖资质</p>
								<p className="intro-item-contain">③ 有强效果口碑案例1000</p>
								<p className="intro-item-contain">④ 有多名持续跟随学习5年以上的用户</p>
								<p className="intro-item-contain">⑤ 有普世教育和尊爱学员的情怀</p>
							</div>
							<div className="intro-item">
								<h3 className="intro-item-title">4、四大服务保障</h3>
								<p className="intro-item-contain">① 三师辅导：名师授课，助教点评和班主答疑，三师服务每个学员；</p>
								<p className="intro-item-contain">② 快速响应：当日作业当日点评，学员疑问24点前必回复，100%不留疑问；</p>
								<p className="intro-item-contain">③ 温馨陪伴：打造有温度的学习氛围，营内营外陪伴常在；</p>
								<p className="intro-item-contain">④ 服务保障：平台有监督，24小时内受理，48小时内完结。</p>
							</div>
						</section>
						<section className="intro-lecturer">
							<h2 className="lecturer-name">四、品牌发展历程</h2>
							<div className="intro-item">
								<p className="intro-item-contain">2016.03 公司成立，产品正式面世，获得欢聚时代（YY）创始人李学凌战略天使轮投资；</p>
								<p className="intro-item-contain">2016.04 上线付费话题功能，微信生态内最早提出“直播付费知识”概念的平台；</p>
								<p className="intro-item-contain">2017.06 联合举办知识付费行业峰会，用户规模达到1亿</p>
								<p className="intro-item-contain">2017.10 获得腾讯投资部和腾讯双百计划的千万级人民币A+轮追</p>
								<p className="intro-item-contain">2018.07 正式进攻内容领域，服务2亿用户，合作明星造型师马锐、著名主持人李静、脑科学家洪兰等数十位知名大咖，课程获得大量用户好评；</p>
								<p className="intro-item-contain">2018.11 联合妇联举办“首届中国女性知识服务行业峰会”，奠定国内知识服务行业领先地位；</p>
								<p className="intro-item-contain">2018.12 团中央宣传部调研组莅临千聊视察调研，探讨与共青团合作更好服务引导设年的设想</p>
								<p className="intro-item-contain">2020.03 联合370家品牌共同发声，发起“十万在线教室”公益计划，以科技赋能社会服务，帮助800万学员恢复课业；</p>
								<p className="intro-item-contain">2021.01 联合多家品牌发布《2021知识付费行业研究报告》，洞察知识付费行业趋势；</p>
								<p className="intro-item-contain">2022.05 在2022斯贝瑞奖盛典暨第五届中国品牌经济峰会，凭借线上教育领域亮眼成绩，荣获“年度线上教育最具影响力品牌”奖项；</p>
								<p className="intro-item-contain">2022.06 公司成为中国家庭教育学会及广东省家庭教育研究会会员单位，共同推动家庭教育事业高质量发展；</p>
								<p className="intro-item-contain">2022.06 携手浙江省教育考试院助力高考志愿填报，联合广州市志愿者协会及南粤家政举办”她职得“公益活动帮助更多女性就业；</p>
								<p className="intro-item-contain">2022.08 荣获ISO9001质量管理体系认证证书；</p>
								<p className="intro-item-contain">2022.10 举办“兴趣岛兴趣学堂趣运会：千聊手机摄影大赛”及手机摄影学院年会，多位学员参赛作品荣登《中国摄影报》等专业媒体期刊；</p>
								<p className="intro-item-contain">2023.01 公司荣获“广东省专精特新中小企业”与百度“公信力教育品牌”荣誉；</p>
								<p className="intro-item-contain">2023.02 凭借7年行业沉淀及教育口碑，荣获360智慧商业“2022年度影响力教育品牌”及腾讯研说家庭教育“最佳用户陪伴奖”； </p>
								<p className="intro-item-contain">2023.06 兴趣岛兴趣学堂已成为国内名师更多，课程更全的领先的兴趣学堂品牌，摄影、瑜伽等30门主流课程21门学员数量全国领先。为深耕兴趣教育领域，让更多人通过知识获得美好生活，正式更名为兴趣岛；</p>
								<p className="intro-item-contain">2023.08 响应国家全民健康行动，兴趣岛积极助力广州市体育局指导筹办的2023健康广州减脂大赛；</p>
								<p className="intro-item-contain">2023.09 兴趣岛正式成为中国营养学会（CNS）会员单位，助力全民健康；</p>
								<p className="intro-item-contain">2023.12 联合武当山和武当大学堂，结合世界武当太极大会，举办兴趣岛·趣传承全民太极节，弘扬中华优秀传统文化。</p>
							</div>
						</section>
						<section className="intro-lecturer">
							<h2 className="lecturer-name">五、品牌荣誉</h2>
							<div className="intro-item">
								<p className="intro-item-contain">1. 2017年2月：获首届中国新常态企业社会责任领袖峰会“中国新常态社会责任企业新锐奖”；</p>
								<p className="intro-item-contain">2. 2017年3月：获得国家发改委颁布的最具潜力新锐企业奖；</p>
								<p className="intro-item-contain">3. 2018年12月：获南方财经全媒体集团“2018年度先锋知识服务平台”；</p>
								<p className="intro-item-contain">4. 2018月1月：获2017中国知识服务峰会“2017年度知识服务平台”大奖；</p>
								<p className="intro-item-contain">5. 2019年12月：荣登2019年广州未来“独角兽”创新企业榜单；</p>
								<p className="intro-item-contain">6. 2019年12月：荣登“2019粤港澳大湾区新经济企业TOP100”榜单；</p>
								<p className="intro-item-contain">7. 2019年12月：获得艾媒咨询颁发的“2019新经济行业年度巅峰榜·中国年度创新知识平台”荣誉；</p>
								<p className="intro-item-contain">8. 2019年12月：荣获由腾讯微信颁发的“微信年度教育行业业务创新奖”；</p>
								<p className="intro-item-contain">9. 2020年8月： 获得广州互联网企业风云榜最具成长力企业称号；</p>
								<p className="intro-item-contain">10. 2020年11月：获得德勤2020广州高科技高成长20强榜单第四名；</p>
								<p className="intro-item-contain">11. 2020年12月：公司创始人朱峻修获得广州市天河区杰出人才称号；</p>
								<p className="intro-item-contain">12. 2020年12月：荣登2020年广州未来“独角兽”创新企业榜单；</p>
								<p className="intro-item-contain">13. 2021年9月：荣登广州“未来独角兽”创新企业榜单</p>
								<p className="intro-item-contain">14. 2021年10月：荣获“2021年度互联网最具成长力”企业奖项</p>
								<p className="intro-item-contain">15. 2021年11月：创始人兼CEO朱峻修荣获“天河区创新创业精英人才”称号</p>
								<p className="intro-item-contain">16. 2021年12月：获得2021发现教育新势力计划——年度「新职教」品牌奖项 </p>
								<p className="intro-item-contain">17. 2021年12月：入选“广东省2021年第三批高新技术企业”</p>
								<p className="intro-item-contain">18. 2022年4月：成为广东省家庭教育研究会副会长单位 </p>
								<p className="intro-item-contain">19. 2022年4月：成为中国家庭教育学会会员单位</p>
								<p className="intro-item-contain">20. 2022年7月：荣获2022斯贝瑞奖“年度线上教育最具影响力品牌”</p>
								<p className="intro-item-contain">21. 2022年7月：通过ISO9001质量管理体系认证</p>
								<p className="intro-item-contain">22. 2022年12月：荣获广东省“专精特新中小企业”称号</p>
								<p className="intro-item-contain">23. 2022年12月：荣获“2022年度最具成长力企业”奖项与“两化融合管理体系A级评定证书”</p>
								<p className="intro-item-contain">24. 2023年1月：荣获“2022年度影响力教育品牌”大奖、2022年度家庭教育“最佳用户陪伴奖”</p>
								<p className="intro-item-contain">25. 2023年9月：兴趣岛荣获“2023年中国产业互联网年度领军企业”</p>
								<p className="intro-item-contain">26. 2023年10月：兴趣岛荣获“省级专精特新中小企业”与“创新型中小企业”两项荣誉称号</p>
								<p className="intro-item-contain">27. 2023年11月：兴趣岛荣获CGMA全球管理会计2023年度“最佳管理会计实践”领域中国大奖</p>
								<p className="intro-item-contain">28. 2023年11月：兴趣岛荣获腾讯新闻 · 教育频道“回响中国”2023年度影响力教育品牌</p>
							</div>
						</section>
					</div>
				</div>
			</Layout>
		);
	}
}

/**
 * mapStateToProps
 */
function mapStateToProps(state: any): any {
	return {};
}

const mapActionToProps: any = {};

export default connect(mapStateToProps, mapActionToProps)(AboutQlEdu);
